import { serverApi } from '../utils/request'
import Paths from 'src/utils/paths'
import { IGoinZoneObject, IZoneObject } from '../types'

class GoinzoneService {
  public async createGoinzone(dto: IZoneObject, orgId: string, serviceId: string) {
    return await serverApi.post(Paths.trips.zoneIndex, dto)
  }

  public async createServiceZoneHotspot(dto: IZoneObject, orgId: string, serviceId: string) {
    return await serverApi.post(Paths.serviceDesignatedZoneBaseUrl, dto)
  }

  public async getGoinzones(orgId: string, serviceId?: string) {
    const result = await serverApi.get(`${Paths.trips.zoneIndex}`, {
      params: {
        organizationId: orgId,
        serviceId
      }
    })
    const data: IZoneObject[] = result.data as IZoneObject[]
    /*
    const zones = data.map((gz: IGoinZoneObject) => {
      gz.coordinates = JSON.parse(gz.coordinates)
      gz.geojson = JSON.parse(gz.geojson)
      return gz
    })
    */

    return data
  }

  public async getAllGoinzones(orgId: string) {
    const result = await serverApi.get(`${Paths.trips.zoneAll}`, {
      params: {
        organizationId: orgId
      }
    })
    const data: IZoneObject[] = result.data as IZoneObject[]

    return data
  }

  public async getGoinzonesByLocations(locations: Array<{ lat: number; lng: number }>) {
    const result = await serverApi.post(`${Paths.trips.getByLocations}`, {
      locations
    })
    const data: IZoneObject[] = result.data as IZoneObject[]
    return data
  }

  public async removeGoinzone(id: string) {
    const path = Paths.trips.zoneDetail.replace(':id', id)
    return await serverApi.delete(path)
  }

  public async updateGoinzone(dto: any, orgId: string, serviceId: string) {
    return await serverApi.put(Paths.trips.zoneIndex, {
      ...dto,
      organizationId: orgId,
      serviceId,
      coordinates: JSON.stringify(dto.coordinates),
      geojson: JSON.stringify(dto.geojson)
    })
  }
}

const goinzoneService = new GoinzoneService()
export { goinzoneService }



// WEBPACK FOOTER //
// ./src/services/Goinzones.ts